module.exports = __webpack_public_path__ + "static/CrimsonText-Bold-43f6b1a4852fe3616c02ed74ca30f45f.woff";